import TkInfoManual from "../../components/atoms/TkInfoManual";
import { stepperData, tableHeadList } from "./parts";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { TkStepper } from "../../components/atoms/TkStepper";
import TkButton from "../../components/atoms/TkButton";
import { ISampleTableData } from "../../type/componentsType/TkFacilityTableChanger";
import { Box } from "@mui/material";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFacilityTableChanger from "../../components/molecules/TkFacilityTableChanger";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import "./_style.scss";
import {
  IAPI_FAC014_Request,
  IAPI_FAC027_Request,
  IAPI_FAC034_Response,
} from "../../type/apiType";
import { httpAPI_FAC014, httpAPI_FAC027, httpAPI_FAC034 } from "./api/request";
import { FacilityKind } from "../../assets/data/Constants";
import { TkRouteContext } from "../../context/tkRouteContext";
import { ITkBreadcrumbsItemProps } from "../../type/componentsType/TkBreadcrumbs";
import { toNumberOrUndefined } from "../../utils/useTools";

/**
 * SCRC050103コンポーネント。
 * このコンポーネントは、TkInfoManual,TkMessageDialog,TkFacilityTableChangerをレンダリングします。
 * @returns JSX.Element SCRC050103 新規契約情報入力（施設情報）一覧
 */
const SCRC050103 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  //初期表示API取得結果
  const [apiGetData, setApiGetData] = useState<IAPI_FAC034_Response>();
  const [aBodyList, setABodyList] = useState<any>();
  //削除用APIリクエスト
  const [httpDeleteReq, setDeleteHttpReq] = useState<IAPI_FAC014_Request>({
    applyId: 0,
    facilityNo: "",
  });
  //テーブルのBody
  const [bodyList, setBodyList] = useState<ISampleTableData[] | undefined>([]);
  //一時保存ダイヤログ
  const [openSuccess, setOpenSuccess] = useState(false);
  //削除ダイヤログ
  const [openSuccessDelete, setOpenSuccessDelete] = useState(false);
  //業務用Contextを更新するState
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  //グローバルContextを更新するState
  const { state, setState } = useContext(GlobalContext);
  //職員登録情報が活性化非活性か判断するフラグ
  const { state: stateRouter, setState: setStateRouter } =
    useContext(TkRouteContext);
  const routerList = stateRouter.routerList || [];
  const newItem: ITkBreadcrumbsItemProps = {
    title: "",
  };
  useEffect(() => {
    //初期表示時に初期表示APIを呼び出し、取得結果とステッパーをState変数に設定する。
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (location.state?.deleteFlg) {
      if (stateRouter) {
        if (
          !stateRouter.routerList?.find((item) => item?.href === "/SCRC050101")
        ) {
          return;
        }
        let updatedRouterState = stateRouter.routerList?.filter(
          (item) => item?.href !== "/SCRC050101"
        );

        if (
          !stateRouter.routerList?.find((item) => item?.href === "/SCRC050103")
        ) {
          updatedRouterState?.push({
            title: "施設等新設届の職員情報登録",
            href: "/SCRC050103",
          });
        }

        if (!!location.state?.wantToSetInRouterList?.length) {
          updatedRouterState = [
            location.state?.wantToSetInRouterList[0],
            {
              title: "施設等新設届の職員情報登録",
              href: "/SCRC050103",
            },
          ];
        }

        setStateRouter({
          ...stateRouter,
          routerList: updatedRouterState,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateRouter]);

  //初期表示時にAPI取得結果をもとに、TkFacilityTableChangerのテーブルの中身をsetする。
  useEffect(() => {
    if (apiGetData) {
      let resArr = apiGetData?.facilityList;

      let bodyinput: ISampleTableData[] | undefined = resArr?.map((item) => {
        let facilityList: ISampleTableData = {
          id: item.facilityNo, // 施設表示順
          No: item.facilityNo, // 施設番号
          FName: item.facilityName, // 施設名称
          FType: FacilityKind[item.facilityKind as keyof typeof FacilityKind], // 施設種類
          allApplicationPerson: item.totalStaffNum, // 職員総数
          joinStaffNum: item.joinStaffNum, // 加入職員数
          yearJoindisableStaffNum: item.yearJoindisableStaffNum, // 雇用期間1年未満職員数
          timeJoindisableStaffNum: item.timeJoindisableStaffNum, // 労働時間2/3未満職員数
          staffRegistrationStatus: item.staffRegistrationStatus, //職員情報登録状況
          facilityInfoModify: (
            <Box className="SCRC050103FixAndDeleteButton">
              <Box className="SCRC050103fixButton">
                <TkButton
                  data-testid="fixButton"
                  onClick={() => handleFix(item.facilityNo)}
                >
                  修正
                </TkButton>
              </Box>
              <Box className="SCRC050103deleteButton">
                <TkButton
                  data-testid="deleteButton"
                  onClick={() => onCheckAndSubmitDelete(facilityList.No)}
                >
                  削除
                </TkButton>
              </Box>
            </Box>
          ),
          stuffInfoRegistration: (
            <Box className="SCRC050103StuffInfoResister">
              <TkButton
                data-testid="StuffInfoResister"
                onClick={() =>
                  handleStuffInfoResister(
                    item.foundDate,
                    item.facilityName,
                    item.facilityNo,
                    item.facilityKind,
                    item.staffRegistrationStatus,
                    item.noJoinFlg,
                    item.partialReleaseFlg
                  )
                }
              >
                職員情報登録
              </TkButton>
            </Box>
          ),
        };
        return facilityList;
      });
      setBodyList(bodyinput);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiGetData]);

  //初期表示API
  const handleInit = async () => {
    try {
      const res = await httpAPI_FAC034({
        applyId: businessState.job_15?.applyId,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        setBusinessState({
          ...businessState,
          job_15: {
            ...businessState.job_15,
            facilityNo: null as any,
            facilityName: "",
            facilityKind: "",
            foundDate: "",
            staffRegistrationStatus: "",
            noJoinFlg: "",
            partialReleaseFlg: "",
          },
        });

        setApiGetData(res);
      } else {
        setState({ ...state, errorMsgId: res.resultCd });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //修正ボタン用イベント
  const handleFix = (facilityNo: any) => {
    setBusinessState({
      ...businessState,
      job_15: {
        ...businessState.job_15,
        facilityNo: facilityNo,
      },
    });

    setStateRouter({
      ...state,
      routerList: [...routerList.slice(0, routerList.length), newItem],
    });
    navigate("/SCRC050101");
  };

  //施設追加ボタン用イベント
  const handleEdit = () => {
    setBusinessState({
      ...businessState,
      common: {
        ...businessState.common,
        contractorNo:
          state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
            ? businessState.common?.contractorNo
            : state.authInfo?.contractorNo,
      },
      job_15: {
        ...businessState.job_15,
        facilityList: apiGetData?.facilityList,
        signUpFlg: true,
      },
    });
    navigate("/SCRC050101");
  };

  //職員情報登録ボタン用イベント
  const handleStuffInfoResister = (
    foundDate: string | undefined,
    facilityName: string | undefined,
    facilityNo: string | undefined,
    facilityKind: string | undefined,
    staffRegistrationStatus: string | undefined,
    noJoinFlg: string | undefined,
    partialReleaseFlg: string | undefined
  ) => {
    setBusinessState({
      ...businessState,
      job_15: {
        ...businessState.job_15,
        foundDate: foundDate,
        facilityName: facilityName,
        facilityNo: facilityNo,
        facilityKind: facilityKind,
        staffRegistrationStatus: staffRegistrationStatus,
        noJoinFlg: noJoinFlg,
        partialReleaseFlg: partialReleaseFlg,
      },
    });
    navigate("/SCRC050104");
  };

  //削除用イベント：リクエストに使用するデータを受け取って、各種State変数にSetStateする。
  const onCheckAndSubmitDelete = (facilityNo: string | undefined) => {
    setDeleteHttpReq({ ...makeHttpDeleteObj(facilityNo) });
    setOpenSuccessDelete(true);
  };

  //削除用APIを呼び出して、その後初期表示するイベント
  const handleOKDelete = async () => {
    try {
      const res = await httpAPI_FAC014({
        ...httpDeleteReq,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        handleInit();
        setOpenSuccessDelete(false);
        navigate("/SCRC050103");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleUpdate = async (type: "save" | "submit") => {
    try {
      const res = await httpAPI_FAC027({ ...makeHttpObj() });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        switch (type) {
          // 一時保存
          case "save":
            setBusinessState({
              ...businessState,
              job_15: {
                ...businessState.job_15,
                tempSaveStep: 1,
              },
            });
            setOpenSuccess(true);
            break;

          // 登録完了
          default:
            // 業務チェック
            let error = apiGetData?.facilityList?.some(
              (item) => item.staffRegistrationStatus === "登録中"
            );
            if (error) {
              setState({
                ...state,
                errorMsgId: "TKMSG_SCR0114E",
              });
              return;
            }

            setBusinessState({
              ...businessState,
              common: {
                ...businessState.common,
                contractorNo:
                  state.authInfo?.userType ===
                  authorityUserType.userTypeNumber.KIKO
                    ? businessState.common?.contractorNo
                    : state.authInfo?.contractorNo,
              },
              job_15: {
                ...businessState.job_15,
                facilityList: apiGetData?.facilityList,
                formList: apiGetData?.formList,
              },
            });

            navigate("/SCRC050105");
            break;
        }
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch {
      navigate("/error");
    }
  };

  // //テーブル行移動並べ替えイベント:
  const changeFacilityNumberModify = (res: any[] | undefined) => {
    let facilityList = res?.map((item) => {
      return {
        facilityNo: item[0]?.id,
        totalStaffNum: toNumberOrUndefined(item[4]?.children?.replace(",", "")),
        joinStaffNum: toNumberOrUndefined(item[5]?.children?.replace(",", "")),
      };
    });

    setABodyList(facilityList);
  };

  /**
   * 更新API用リクエストを作成
   * @param obj リクエスト作成に必要なデータ
   */
  const makeHttpObj = (): IAPI_FAC027_Request => {
    let resArr = aBodyList ?? apiGetData?.facilityList;
    let facilityList = resArr?.map((item: any, index: any) => {
      return {
        facilityNo: item.facilityNo,
        facilityDispOrder: index + 1,
        totalStaffNum: item.totalStaffNum,
        joinStaffNum: item.joinStaffNum,
      };
    });

    const reqObj: IAPI_FAC027_Request = {
      applyId: businessState.job_15?.applyId ? businessState.job_15.applyId : 0,
      facilityList: facilityList,
    };

    return reqObj;
  };

  /**
   * 削除API用リクエストを作成
   * @param obj リクエスト作成に必要なデータ
   */
  const makeHttpDeleteObj = (
    facilityByNo: string | undefined
  ): IAPI_FAC014_Request => {
    const reqObj: IAPI_FAC014_Request = {
      applyId: businessState.job_15?.applyId!,
      facilityNo: facilityByNo!,
    };

    return reqObj;
  };

  return (
    <>
      <Box data-testid="SCRC050103PageForTest" className="SCRC050103View">
        <TkStepper
          steps={stepperData}
          activeStep={0}
          savaStep={businessState.job_15?.tempSaveStep}
        />
        <Box className="SCRC050103InfoManual">
          <TkInfoManual rule={"\\n"}>
            {labelids.labelid.LBLC050103_01}
          </TkInfoManual>
        </Box>

        {state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO && (
          <TkContractorAndNumberLine
            name="契約者（法人）名"
            no={
              businessState.common?.contractorNo! +
              ":" +
              businessState.common?.contractorName!
            }
          />
        )}

        <Box className="SCRC050103facilityEdit">
          <TkButton onClick={() => handleEdit()}>施設追加</TkButton>
        </Box>
        <TkFacilityTableChanger
          facilityList={bodyList}
          headList={tableHeadList}
          onClick={changeFacilityNumberModify}
        />
        <Box className="SCRC050103LabelTextRegisterSuccess">
          <TkInfoManual rule={"\\n"}>
            {labelids.labelid.LBLC050103_02}
          </TkInfoManual>
        </Box>
        <Box>
          <Box className="SCRC050103twoButton">
            <TkBackButton />
            <TkButton
              data-testid="checkAndSubmit"
              onClick={() => handleUpdate("save")}
              disabled={apiGetData?.facilityList?.length === 0}
            >
              一時保存
            </TkButton>
            <TkButton
              data-testid="registerSuccess"
              onClick={() => handleUpdate("submit")}
              disabled={apiGetData?.facilityList?.length === 0}
            >
              登録完了
            </TkButton>
          </Box>
        </Box>
        <TkMessageDialog
          open={openSuccess}
          onOky={() => setOpenSuccess(false)}
          title="一時保存完了"
          contextText="　一時保存が完了しました。"
          okText="はい"
          cancelText=""
        />
        <TkMessageDialog
          open={openSuccessDelete}
          onOky={() => handleOKDelete()}
          onCancel={() => setOpenSuccessDelete(false)}
          title="確認（施設情報を削除します）"
          contextText="　施設情報の削除を行いますが、問題ないでしょうか（選択された施設に紐付いた職員情報もすべて削除されます）。"
          cancelText="いいえ"
          okText="はい"
        />
      </Box>
    </>
  );
};

export default SCRC050103;
